module.exports = __webpack_public_path__ + "img/img8.15e02482.png";